// extracted by mini-css-extract-plugin
export default {"uploadBox":"UploadPhoto_uploadBox__RncLq","uploadInput":"UploadPhoto_uploadInput__cJ9E7","update-btn":"UploadPhoto_update-btn__0JFMl","avatar":"UploadPhoto_avatar__oTFH7"};